import { render, staticRenderFns } from "./UserTraining.vue?vue&type=template&id=b6455592&scoped=true"
import script from "../../../scripts/partials/user/UserTraining.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserTraining.js?vue&type=script&lang=js&external"
import style0 from "./UserTraining.vue?vue&type=style&index=0&id=b6455592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6455592",
  null
  
)

export default component.exports